module.exports = __webpack_public_path__ + "media/images/page/play_ic-f8f70b8224bf48df93d795d40f6eded7.svg";